import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/programs/$programId')({
  beforeLoad: () => {
    throw redirect({ to: '/app/programs' })
  },
})
